const COLOR_BY_CATEGORY_MAP = {
  332: "#826B8E",
  2624: "#0A3A3F",
  357: "#842F48",
  179: "842F48",
  1208: "#7699A6",
  1205: "#6F785E",
  2961: "#22969A",
  1149: "#B88D00",
  1204: "#B88D00",
  1168: "#B88D00",
  1207: "#AA3B17",
  249: "#AA3B17",
  1206: "#AA3B17",
  5735: "#AA3B17",
  4675: "#7699a6",
  168: "#28834C",
};
export const useUtilities = () => {
  const formatPostDate = (start_date: string, end_date?: string): string => {
    const parseDate = (date: string) => {
      return new Date(date);
    };

    const format = (date: Date) => ({
      month: date.toLocaleString("en-US", { month: "long" }),
      day: date.getDate(),
      year: date.getFullYear(),
      monthIndex: date.getMonth(),
    });

    const start = format(parseDate(start_date));
    const end = end_date ? format(parseDate(end_date)) : null;

    if (end) {
      const sameDay =
        start.day === end.day &&
        start.monthIndex === end.monthIndex &&
        start.year === end.year;
      const sameMonth =
        start.monthIndex === end.monthIndex && start.year === end.year;
      const sameYear = start.year === end.year;

      if (sameDay) {
        return `${start.month} ${start.day}, ${start.year}`;
      } else if (sameMonth) {
        return `${start.month} ${start.day}-${end.day}, ${start.year}`;
      } else if (sameYear) {
        return `${start.month} ${start.day} - ${end.month} ${end.day}, ${start.year}`;
      } else {
        return `${start.month} ${start.day}, ${start.year} - ${end.month} ${end.day}, ${end.year}`;
      }
    }

    return `${start.month} ${start.day}, ${start.year}`;
  };

  return {
    colorByCategoryMap: COLOR_BY_CATEGORY_MAP,
    formatDate: (date: Date) => {
      const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months start at 0
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();

      return `${mm}/${dd}/${yyyy}`;
    },
    formatDateISO: (date: Date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    extractEyebrowFromPostSource: (source: any) => {
      const term = source?.terms?.type?.find(
        (term: any) => term.name !== "Events" && String(term.parent) === '169'
      );
      if (term) {
        return {
          name: term.name,
          color: (COLOR_BY_CATEGORY_MAP as any)[Number(term.term_id)] ?? null,
        };
      }
      return null;
    },
    extractEyebrowFromPostDetail: (postDetail: any) => {
      const term = postDetail?.terms.find(
        (term: any) => term.name !== "Events" && String(term.parent) === '169'
      );
      if (term) {
        return {
          name: term.name,
          color: (COLOR_BY_CATEGORY_MAP as any)[Number(term.term_id)] ?? null,
        };
      }
      return null;
    },

    processDateFromPostSource: (source: any) => {
      // Use YYYY-MM-DDTHH:mm:ss to treat as local time
      if (!source.meta.start_date?.[0]?.datetime) {
        return null;
      }
      return formatPostDate(
        source.meta.start_date[0].datetime,
        source.meta.end_date[0].datetime
      );
    },
    extractLocationFromPostSource: (source: any) => {
      const location = {
        city: source.city?.post_title ?? "",
        region: source.region?.post_title ?? "",
        regionLink: source.region?.post_name
          ? `/places-to-go/regions/${source.region.post_name}/`
          : "",
      };
      if (location.region) {
        return location;
      }
      return null;
    },
    extractLocationFromPostDetail: (postDetail: any) => {
      const location = {
        city: postDetail?.acf?.city?.post_title ?? "",
        region: postDetail?.acf?.region?.post_title ?? "",
        regionLink: postDetail?.acf?.region?.post_name
          ? `/places-to-go/regions/${postDetail.acf.region.post_name}/`
          : "",
      };
      if (location.city) {
        return location;
      }
      return null;
    },
  };
};
